export const environment = {
    production: true,
    env: 'qa',
    ROOT_URL: 'https://qa-tnb-tdl.nonprod.k8s.eon.com',
    API_URL: '/api',
    oauth: {
        redirectUrl: window.location.origin + window.location.pathname,
        loginUrl: 'https://westnetz-tnb-portal-stg.eon-ciam-dev.auth0app.com/authorize' +
            '?response_type=code' +
            '&client_id=CVbaE85XvstFgRnW13ScvU1y8iKh4CYm' +
            '&scope=offline_access' +
            '&audience=urn:westnetz:tnbportal:tnbtdl:backend:stg' +
            '&redirect_uri=https://qa-tnb-tdl.nonprod.k8s.eon.com',
        logoutUrl: 'https://westnetz-tnb-portal-stg.eon-ciam-dev.auth0app.com/v2/logout' +
            '?client_id=CVbaE85XvstFgRnW13ScvU1y8iKh4CYm' +
            '&returnTo=https://qa-tnb-tdl.nonprod.k8s.eon.com',
    },
    sentry: {
        dsn: 'https://874d9700e8be4556a259d8488dc74b29@sentry.eon.com/77',
        environment: 'qa',
        enabled: true,
    },
};
